import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { MANDATORY_SUPER_PROPERTIES } from '@adsk/bim360-analytics-sdk-js';
import { connect } from '../../redux/connect';
import WorkflowsModal from './components/WorkflowsModal';
import TableRow from './components/TableRow';

import { WORKFLOWS_ROLE_ARCHITECT, WORKFLOW_A, WORKFLOW_B } from '../../constants/roles-types';
import {
  fetchWorkflowsAction,
  createWorkflowAction,
  updateStateAction,
} from '../../redux/actions/workflows-actions';
import { registerAnalyticsMandatorySuperProps } from '../../redux/actions';
import { objectType } from '../../constants/proptype-validation/index';

import USWorkFlowSvg from './components/USWorkFlowSvg';
import EUWorkFlowSvg from './components/EUWorkFlowSvg';
import { getWorkflow } from '../../redux/selectors';

const getWorkflowsPresets = () => ({
  [WORKFLOW_A]: {
    name: T.translate('adminWorkflow.workflowAName'),
    description: T.translate('adminWorkflow.workflowADescription'),
  },
  [WORKFLOW_B]: {
    name: T.translate('adminWorkflow.workflowBName'),
    description: T.translate('adminWorkflow.workflowBDescription'),
  },
});

class RFIsAdmin extends PureComponent {
  static displayName = 'RFIsAdmin';

  static propTypes = {
    fetchWorkflowsAction: PropTypes.func,
    workflow: objectType,
    createWorkflowAction: PropTypes.func,
    updateStateAction: PropTypes.func,
    registerAnalyticsMandatorySuperProps: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      openAsZoomable: false,
      loading: true,
    };

    this.setModalVisible = this.setModalVisible.bind(this);
  }

  componentWillMount() {
    this.props.fetchWorkflowsAction();
    this.props.registerAnalyticsMandatorySuperProps({
      [MANDATORY_SUPER_PROPERTIES.FEATURE_MODULE]: 'Project Management',
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.workflow) {
      this.setState({ loading: false });
    }
  }

  _loader() {
    return (
      <div>
        <div className="isui-loading-container">
          <div className="isui-loading" />
        </div>
      </div>
    );
  }

  _header() {
    const modalOpen = true;
    const openAsZoomable = false;

    return (
      <div className="row">
        <div className="col-6">
          <div className="head-title">{T.translate('adminWorkflow.rfiWorkflowTitle')}</div>
        </div>
        <div className="col-6">
          <div
            className="head-btn"
            onClick={() => this.setModalVisible({ modalOpen, openAsZoomable })}
          >
            {T.translate('adminWorkflow.changeWorkflow')}
          </div>
        </div>
      </div>
    );
  }

  haveWorkflowData() {
    return !!this.props.workflow;
  }

  _workflowName() {
    if (!this.haveWorkflowData()) {
      return T.translate('adminWorkflow.undefinedWorkflow');
    }

    return getWorkflowsPresets()[this.props.workflow.wfType].name;
  }

  _workflowDescription() {
    if (!this.haveWorkflowData()) {
      return null;
    }

    return getWorkflowsPresets()[this.props.workflow.wfType].description;
  }

  renderWorkflowIcon() {
    if (this.props.workflow.wfType === WORKFLOW_A) {
      return <USWorkFlowSvg />;
    }
    return <EUWorkFlowSvg />;
  }

  _current() {
    const modalOpen = true;
    const openAsZoomable = true;

    return (
      <div>
        <div className="row">
          <div className="col-5">
            <div className="table-title">{T.translate('adminWorkflow.workflowName')}</div>
          </div>
          <div className="col-7">
            <div className="table-title">{T.translate('new.description')}</div>
          </div>
        </div>
        <div className="divider" />
        <div className="row">
          <div className="col-5">
            <div className="workflow-name">
              {this._workflowName()}
              {this.props.workflow.wfType === WORKFLOW_A ? (
                <div className="default-icon">{T.translate('adminWorkflow.defaultCapital')}</div>
              ) : null}
            </div>
          </div>
          <div className="col-7">
            <div className="description">
              {this._workflowDescription()}
              <div
                className="view-workflow"
                onClick={() => this.setModalVisible({ modalOpen, openAsZoomable })}
              >
                {T.translate('adminWorkflow.extendWorkflow')}
              </div>
              {this.renderWorkflowIcon()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  _emptyFieldsAlert() {
    return this.props.workflow.states.some((states) => states.data.assignees.length === 0) ? (
      <div className="head-error">{T.translate('adminWorkflow.configurationIsIncomplete')}</div>
    ) : null;
  }

  _table() {
    if (!this.props.workflow) {
      return null;
    }

    const {
      workflow: { states },
    } = this.props;
    const rows = (states || []).map((state, i) => {
      const rollDisplayName = T.translate(
        `adminWorkflow.rols.${
          state.name === WORKFLOWS_ROLE_ARCHITECT
            ? `${state.name}.${this.props.workflow.wfType}`
            : state.name
        }`
      );
      return (
        <TableRow
          key={state.id}
          name={state.name}
          description={state.description}
          role={rollDisplayName}
          pos={i}
          serverData={state.data && state.data.assignees ? state.data.assignees : []}
          save={(data) => {
            this.props.updateStateAction(state.id, { data });
          }}
        />
      );
    });

    return (
      <div className="table-view">
        <div className="row">
          <div className="col-5">
            <div className="table-title">{T.translate('assignment.workflowRole')}</div>
          </div>
          <div className="col-7">
            <div className="table-title">{T.translate('assignment.workflowRoleType')}</div>
          </div>
        </div>
        {rows}
      </div>
    );
  }

  setModalVisible({
    modalOpen = this.state.modalOpen,
    openAsZoomable = this.state.openAsZoomable,
  }) {
    this.setState({ modalOpen, openAsZoomable });
  }

  _content() {
    return (
      <div>
        <WorkflowsModal
          open={this.state.modalOpen}
          openAsZoomable={this.state.openAsZoomable}
          setModalVisible={this.setModalVisible}
          presets={getWorkflowsPresets()}
          currentType={this.props.workflow.wfType}
          createWorkflow={this.props.createWorkflowAction}
        />
        {this._header()}
        {this._emptyFieldsAlert()}
        {this._current()}
        {this._table()}
      </div>
    );
  }

  render() {
    return (
      <div className="admin-container">{this.state.loading ? this._loader() : this._content()}</div>
    );
  }
}

const mapStateToProps = (state) => ({
  workflow: getWorkflow(state),
});

const mapDispatchToProps = {
  fetchWorkflowsAction,
  createWorkflowAction,
  updateStateAction,
  registerAnalyticsMandatorySuperProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(RFIsAdmin);
